import {BaseOfferClickManager} from '../../../application/clickManagers/BaseOfferClickManager';

class FinOfferClickManager extends BaseOfferClickManager
{
    static get entitySelector() {
        return '[data-list="fin-offer"]';
    }

    static get clickButtonSelector() {
        return '[data-fin-offer="click"]';
    }

    static get storageClickedKey() {
        return 'clickedFinOffers';
    }

    static get conditionsButtonSelector() {
        return '[data-offer="toggle-conditions"]';
    }

    static get conditionsSelector() {
        return '[data-offer="conditions"]';
    }

    static get urlParamName() {
        return 'fid';
    }
}

export {FinOfferClickManager}
